export default "__VITE_PUBLIC_ASSET__a159a26a__"